define('scheduler/scheduler-container',['require','knockout','web-urls','plugins/dialog','dialog-helper/responsive','durandal/app','lib/auth/auth','api-access','i18next','invite-component/invite-component-container','lib/ajax-failure-handler/ajax-failure-handler','tealium-utils'],function (require) {
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var dialog = require('plugins/dialog');
    var responsiveDialog = require('dialog-helper/responsive');
    var app = require('durandal/app');
    var auth = require('lib/auth/auth');
    var gotomeet = require('api-access').gotomeet;
    var i18n = require('i18next');
    var Invite = require('invite-component/invite-component-container');
    var handleAjaxFailure = require('lib/ajax-failure-handler/ajax-failure-handler');
    var tealiumUtils = require('tealium-utils');

    var Scheduler = function (meetingId, isRoom, showVariation) {
        var self = this;
        self.isRoom = isRoom;
        self.showModal = ko.observable(true);
        self.showSpinner = ko.observable(true);
        self.iframeUrl = webUrls.get('baseUrl') + '/public/scheduler/latest/index.html';

        function handleMessage(event) {
            var data = event.data;
            if (data) {
                var message = data.message;
                var contents = data.contents ? JSON.parse(data.contents) : undefined;

                var messages = {
                    loaded: function () {
                        document.querySelector('#scheduler-iframe').contentWindow.postMessage({
                            message: 'initialize',
                            contents: {
                                hideOptions: !!self.isRoom,
                                hideTime: !!showVariation,
                                hidePlugins: !!showVariation,
                                lng: i18n.lng(),
                                meetingId: meetingId,
                                newHeadline: !!showVariation,
                                token: auth.getToken().access_token,
                                headers: {
                                    ClientName: 'meeting-frontend'
                                }
                            }
                        }, self.iframeUrl);
                    },

                    cancel: function () {
                        app.trigger('scheduleModal:canceled');
                        self.close();
                    },

                    save: function () {
                        self.close();
                        app.trigger('get:meetings');
                        app.trigger('meeting:scheduled');

                        var eventName = meetingId ? 'Edit a Meeting' : 'Schedule a Meeting';
                        var audioContent = contents.audio;
                        var mixpanelData = meetingId ?
                        {
                            ID: contents.meetingId,
                            Type: contents.meetingType
                        }
                            :
                        {
                            ID: contents.meetingId,
                            Type: contents.meetingType,
                            'Audio Voip': audioContent.audioType.toLowerCase().includes('voip'),
                            'Audio Toll': !!(audioContent.tollCountries && audioContent.tollCountries.length > 0),
                            'Audio TollFree': !!(audioContent.tollFreeCountries && audioContent.tollFreeCountries.length > 0),
                            'Audio Callme': audioContent.isDialOut,
                            'Audio Private': audioContent.audioType === 'private'
                        };
                        window.mixpanel.track(eventName, mixpanelData);

                        if (self.isRoom) {
                            gotomeet.getByUserKey().then(function (res) {
                                gotomeet.createMeetingRoom(res.profileId, contents.meetingId);
                            });
                        }
                        Invite.show(contents.meetingId);
                    },

                    dimensions: function () {
                        var schedulerElement = document.querySelector('.scheduler-iframe');

                        if (self.showSpinner()) {
                            self.showSpinner(false);
                        }

                        if (schedulerElement) {
                            schedulerElement.style.height = contents.height + 'px';

                            // Trigger resize to center modal
                            var modalElement = document.getElementById('scheduler-container');
                            modalElement.style.height = ''; // Needs to be cleared, for scroll to work.
                            dialog.getContext().reposition(modalElement);

                            app.trigger('scheduleModal:shown');
                        }
                    },

                    meetingNameFocused: function () {
                        app.trigger('scheduleModal:meetingNameFocused');
                    },

                    requestFailure: function () {
                        handleAjaxFailure(contents.jqXHR, contents.operation, contents.url);
                    }
                };
                if (event.source.location.href === self.iframeUrl && messages[message]) {
                    messages[message]();
                }
            }
        }

        self.close = function () {
            dialog.close(self);
            window.removeEventListener('message', handleMessage);
        };

        self.activate = function () {
            window.addEventListener('message', handleMessage);
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
        };
    };

    Scheduler.show = function (meetingId, isRoom, showVariation) {
        tealiumUtils.sendTealiumEvent('meetings', 'schedule-meeting');
        return dialog.show(new Scheduler(meetingId, isRoom, showVariation));
    };

    return Scheduler;
});


